import { useTheme } from '@mui/material/styles';

/**
 * Colors for AI Ecosystem related components and pages
 */
export const Colors = {
  Themes: {
    Light: {
      type: 'light',
      backgroundDefault: '#F4F4F4',
      backgroundPaper: '#FFFFFF',
      warning: '#E8BD00',
      warningLight: '#fdf9ea',
      Dialogs: {
        background: '#FFFFFF',
      },
      AgentStatusChip: {
        production: '#198025',
        development: '#005495',
        deprecated: '#B22222',
        review: '#D1AA00',
        supportsa2a: '#1FA3A3',
        supportsmcp: '#7C30E6',
      },
      ModelCard: {
        background: '#F4F4F4',
        label: '#666666',
        icon: '#666666',
        link: '#0A6ED1',
        statusProduction: '#198025',
        statusTesting: '#B38000',
        statusDeprecated: '#B22222',
      },
      Skeleton: {
        cardBackgroundColor: '#E8E8E8',
      },
      Leaderboard: {
        highlightColumnHeader: '#B4DDFE',
        normalColumnHeader: '#F4F4F4',
        highlightColumn: '#E6F5FF',
        columnShadow: '4px 0 6px -2px rgba(0, 0, 0, 0.15)',
        sortActiveIcon: '#0078D6',
        sortInactiveIcon: '#848484',
      },
      McpServers: {
        Status: {
          Public: '#21A330',
          Internal: '#7C30E6',
        },
      },
      TemplatesCard: {
        background: '#F4F4F4',
        template: '#7C30E6',
        addon: '#21A330',
        blueprint: '#1998FC',
      },
    },
    Dark: {
      type: 'dark',
      backgroundDefault: '#0D0D0D',
      backgroundPaper: '#1A1A1A',
      warning: '#FACC00',
      warningLight: '#191505',
      Dialogs: {
        background: '#222222',
      },
      AgentStatusChip: {
        production: '#84E18F',
        development: '#33A3FC',
        deprecated: '#D55353',
        review: '#FACC00',
        supportsa2a: '#1FA3A3',
        supportsmcp: '#9B5BEE',
      },
      ModelCard: {
        background: '#0D0D0D',
        label: '#C5C5C5',
        icon: '#C5C5C5',
        link: '#4AA3FF',
        statusProduction: '#218330',
        statusTesting: '#F7B100',
        statusDeprecated: '#D55353',
      },
      Skeleton: {
        cardBackgroundColor: '#262626',
      },
      Leaderboard: {
        highlightColumnHeader: '#003156',
        normalColumnHeader: '#0D0D0D',
        highlightColumn: '#00182C',
        columnShadow: '4px 0 6px -2px rgba(1, 1, 1, 0.85)',
        sortActiveIcon: '#008DFC',
        sortInactiveIcon: '#848484',
      },
      McpServers: {
        Status: {
          Public: '#7AC883',
          Internal: '#8371F0',
        },
      },
      TemplatesCard: {
        background: '#0D0D0D',
        template: '#7C30E6',
        addon: '#7AC883',
        blueprint: '#4EAFFD',
      },
    },
  },
};

/**
 * Hook to determine if the current theme is dark mode.
 * @returns True if the current theme is dark mode, false otherwise.
 */
export function useIsDarkMode(): boolean {
  return useTheme().palette.mode === Colors.Themes.Dark.type;
}

/**
 * Get the colors for the ModelCard component based on the current theme.
 * @param isDarkMode - True if the current theme is dark mode, false otherwise.
 * @returns The colors for the ModelCard component.
 */
export const getModelCardColors = (isDarkMode: boolean) => {
  return isDarkMode
    ? Colors.Themes.Dark.ModelCard
    : Colors.Themes.Light.ModelCard;
};
